import { User } from "src/types/userTypes";
import { logoutCurrentUser } from "src/views/pages/login/Login";
import { useQueryClient } from "react-query";

export function useGetUserDetails(): User | null {
  const queryClient = useQueryClient();

  let userDetail = localStorage.getItem("nuclearn_user");
  // if we can't set the user details or run into an error parsing the token, force a re-login
  if (!userDetail || userDetail === "undefined") {
    logoutCurrentUser(queryClient);
    return null; // Ensure a return value is provided
  } else {
    return JSON.parse(userDetail);
  }
}
